t = require('app/scripts/views/internal/teacup-with-helpers')('member_session')

module.exports = ->
  t.mustacheBlock 'type_support', ->
    t.p '.u-bottom', ->
      t.format 'authorization-for-trello-support-ticket-data-ticket', { 'data.ticket': t.mustacheVar('data.ticket') }
      t.br()
      t.span '.quiet', ->
        t.format 'expires', { dateExpires: t.mustacheVar('dateExpires') }
        t.raw ' '
        t.a '.quiet.js-revoke', { href: '#' }, ->
          t.format 'revoke'

  t.mustacheBlockInverted 'type_support', ->
    t.p '.u-bottom', ->
      t.strong ->
        t.text t.mustacheVar('ipAddress')
      t.span '.quiet'
      t.br()
      t.span '.quiet', ->
        t.mustacheBlock 'isRecent', ->
          t.mustacheBlock 'isCurrent', ->
            t.format 'last-used-less-than-an-hour-ago-current-session'
          t.mustacheBlockInverted 'isCurrent', ->
            t.format 'last-used-less-than-an-hour-ago'
        t.mustacheBlockInverted 'isRecent', ->
          t.mustacheBlock 'isCurrent', ->
            t.format 'last-used-current-session', { dateLastUsed: t.mustacheVar('dateLastUsed') }
          t.mustacheBlockInverted 'isCurrent', ->
            t.format 'last-used', { dateLastUsed: t.mustacheVar('dateLastUsed') }
